import { SpaceProps, Space as AntSpace } from 'antd';
import './antStyle.scss';

const Space: React.FC<SpaceProps> = ({ ...props }) => {
  return <AntSpace {...props} />;
};
export default Space;
